module.exports = __webpack_public_path__ + "img/dyp09.6c120276.jpg";